import React, { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";

import { exchangeHandoffCode } from "services/auth/portalHandoff";
import { AuthUserSuccess } from "store/actions/AuthUser";
import { isSafeInternalRoute, withCampaignParams } from "util/postLoginRedirect";

import "./Sso.scss";

function SsoScreen() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const ran = useRef<boolean>(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;

    const code = searchParams.get("code");
    if (!code) {
      navigate("/", { replace: true });
      return;
    }

    (async () => {
      try {
        const response = await exchangeHandoffCode(code);
        if (response?.ok && response?.status === 201) {
          // AUTH_USER_SUCCESS writes accessToken/refreshToken/loggedInUser/permissionTable.
          dispatch(AuthUserSuccess(response));

          // `next` is cross-origin-supplied, so the open-redirect guard is load-bearing. It
          // already carries its own query string (utm included, merged in on the sender side),
          // so it's used as-is — only the dashboard fallback needs campaign params attached.
          const next = searchParams.get("next");
          const destination = next && isSafeInternalRoute(next) ? next : withCampaignParams("/main/dashboard");
          navigate(destination, { replace: true });
        } else {
          navigate("/?ssoError=1", { replace: true });
        }
      } catch (e) {
        navigate("/?ssoError=1", { replace: true });
      }
    })();
  }, [dispatch, navigate, searchParams]);

  return <div className="sso-screen">Signing you in…</div>;
}

export default SsoScreen;
